import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { withStyles } from '@material-ui/styles';

export const FixedWidthTable = withStyles(() => ({ root: { tableLayout: 'fixed', width: '100%' } }))(Table);

export const FlexTableRow = withStyles(() => ({ root: { display: 'flex' } }))(TableRow);

export const FabTableCell = withStyles(() => ({
  body: {
    display: 'block',
    width: '40px',
  },
  head: {
    display: 'block',
    width: '40px',
  },
}))(TableCell);

export const MileageTableCell = withStyles(() => ({
  body: {
    display: 'block',
    width: '120px',
  },
  head: {
    display: 'block',
    width: '120px',
  },
}))(TableCell);

export const RideTableCell = withStyles(() => ({
  body: {
    display: 'block',
    minWidth: '120px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  head: {
    display: 'block',
    minWidth: '120px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
}))(TableCell);

export const RouteBlockageTableCell = withStyles(() => ({
  body: {
    display: 'block',
    flexGrow: 1,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  head: {
    display: 'block',
    flexGrow: 1,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
}))(TableCell);
